import { ECLIPSE_BUSINESS_PRODUCT_FAMILY_ID, ECLIPSE_CORE_PRODUCT_FAMILY_ID } from '@wix/package-picker-shared';
const TIER_BY_PRODUCT_FAMILY_ID = {
  [ECLIPSE_CORE_PRODUCT_FAMILY_ID]: 'core',
  [ECLIPSE_BUSINESS_PRODUCT_FAMILY_ID]: 'business'
};
export const buildPlanRecommendationRequestBody = function (catalog, _temp) {
  let {
    siteGuid,
    referral
  } = _temp === void 0 ? {} : _temp;
  const {
    products,
    features,
    recommendedProductFamily
  } = catalog;
  if (!products) {
    return null;
  }
  const recommendedFamilyId = (recommendedProductFamily == null ? void 0 : recommendedProductFamily.productFamilyId) ?? ECLIPSE_BUSINESS_PRODUCT_FAMILY_ID;
  const recommended = products.find(p => p.productFamilyId === recommendedFamilyId);
  if (!(recommended != null && recommended.productId) || !(recommended != null && recommended.name)) {
    return null;
  }
  const toFeatureTranslationKeys = productId => features.getByProductId(productId).flatMap(f => {
    var _f$content;
    const translationKey = (_f$content = f.content) == null || (_f$content = _f$content.localized) == null ? void 0 : _f$content.translationKey;
    return f.active !== false && translationKey ? [translationKey] : [];
  });
  const featureTranslationKeys = toFeatureTranslationKeys(recommended.productId);
  const candidates = products.reduce((acc, product) => {
    const tier = product.productFamilyId ? TIER_BY_PRODUCT_FAMILY_ID[product.productFamilyId] : undefined;
    if (tier && product.productId && product.name) {
      acc.push({
        tier,
        productId: product.productId,
        productName: product.name,
        featureTranslationKeys: toFeatureTranslationKeys(product.productId)
      });
    }
    return acc;
  }, []);
  return {
    recommendedProductIdFallback: recommended.productId,
    recommendedProductNameFallback: recommended.name,
    featureTranslationKeys,
    siteGuid,
    candidates,
    referral
  };
};
//# sourceMappingURL=build-plan-recommendation-request-body.js.map